module.exports = __webpack_public_path__ + "images/icons/icon-plus-d58d6382.svg";